import { CREATE_ORDER, CREATE_ORDER_SUCCESS, CREATE_ORDER_FAILURE, CLEAR_ORDER_CONFIRMATION } from '../types';


export const createOrder = (orderData) => ({
  type: CREATE_ORDER,
  payload: orderData
});

export const createOrderSuccess = (response) => ({
  type: CREATE_ORDER_SUCCESS,
  payload: response
});

export const createOrderFailure = (error) => ({
  type: CREATE_ORDER_FAILURE,
  error: error
});

export const clearOrderConfirmation = () => ({
  type: CLEAR_ORDER_CONFIRMATION
});
